import { render, staticRenderFns } from "./VariantSifterV2gDrawer.vue?vue&type=template&id=296a7154&scoped=true&"
import script from "./VariantSifterV2gDrawer.vue?vue&type=script&lang=js&"
export * from "./VariantSifterV2gDrawer.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterV2gDrawer.vue?vue&type=style&index=0&id=296a7154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296a7154",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('296a7154')) {
      api.createRecord('296a7154', component.options)
    } else {
      api.reload('296a7154', component.options)
    }
    module.hot.accept("./VariantSifterV2gDrawer.vue?vue&type=template&id=296a7154&scoped=true&", function () {
      api.rerender('296a7154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterV2gDrawer.vue"
export default component.exports